import { createApp } from 'vue'
import App from './App.vue'
import { DARK_QUERY, followColorScheme } from './lib/colorScheme'
import './styles/base.css'
// Resolved by rsbuild to the VITE_BRAND theme package.
import '@theme'

followColorScheme(document.documentElement, window.matchMedia(DARK_QUERY))
createApp(App).mount('#app')
